import { na1 } from 'hubspot-url-utils/hublets';
import { getFullUrlPure } from 'hubspot-url-utils/pure';
const buildHubspotUrl = ({
  subDomainPrefix,
  hublet,
  isQa,
  pathname = '',
  pathValues = {},
  domainOverride,
  tldOverride,
  query
}) => {
  const path = Object.keys(pathValues).reduce((accm, key) => {
    return accm.replace(RegExp(`{{${key}}}`, 'g'), pathValues[key]);
  }, pathname);
  const origin = getFullUrlPure(subDomainPrefix, hublet || na1, isQa ? 'qa' : 'prod', {
    domainOverride,
    tldOverride
  });
  const url = new URL(path, origin);
  if (query) {
    for (const [key, value] of Object.entries(query)) {
      url.searchParams.append(key, value);
    }
  }
  return url.href;
};
export default buildHubspotUrl;